import i18n from '@/i18n';
import { Base64 } from 'js-base64';
import Cookies from 'js-cookie';

// 是否嵌入页路由
export function isEmbed(path) {
  const checkPath = path || window.location.pathname;
  return checkPath.indexOf('/embed/') > -1;
}

// 是否企微使用路由
export function isWxwork(path) {
  const checkPath = path || window.location.pathname;
  return checkPath.indexOf('/wxwork/') > -1;
}

// 是否企业微信(企微)环境
export function isComWx() {
  const ua = navigator.userAgent.toLowerCase();
  const isComWx = ua.indexOf('wxwork') > -1;
  return isComWx;
}
export const sessionOrLocal = {
  set: (key, value, saveType = 'sessionStorage') => {
    if (!key) return;
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    // alert(`当前${sessionOrLocal.saveType}`);
    window[saveType].setItem(key, value);
  },
  get: (key, saveType = 'sessionStorage') => {
    if (!key) return;
    return window[saveType].getItem(key);
  },
  removeItem: (key, saveType = 'sessionStorage') => {
    if (!key) return;
    window[saveType].removeItem(key);
  },
  clear: (saveType = 'sessionStorage') => {
    window[saveType].clear();
  }
};

// 清空Cookies
export const clearCookies = () => {
  const keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (let i = keys.length; i--; ) {
      // document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
      Cookies.remove(keys[i], {
        path: ''
      });
      Cookies.remove(keys[i], {
        path: '/'
      });
    }
  }
  // 重点关注如何清空缓存key
  // Cookies.remove('token', { path: '' })
  // Cookies.remove('sso_token', { path: '' })
};

// 解析token
export const parseToken = token => {
  try {
    const tokenJson = JSON.parse(base64Decode(token.split('.')[1]));
    return tokenJson;
  } catch {
    return null;
  }
};
export function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 * 获取url的参数
 * @param {*} name
 * @param {*} optioins
 */
export function getLocationParameters(key) {
  if (key) {
    // 有key值，返回它的value
    let reg = new RegExp('[?&]' + key + '=([^&]*)[&$]*');
    let ret = (window.location.hash || window.location.search).match(reg);
    if (ret) {
      ret = decodeURIComponent(ret[1]);
    }
    return ret || '';
  } else {
    // 没有key值，返回所有
    const queryParams = window.location.search.substring(1); // 获取 query 字符串，不包括 '?'。
    const hashParams = window.location.hash.substring(1); // 获取 hash 字符串，不包括 '#'。
    const params = {};
    // 解析查询参数
    queryParams.split('&').forEach(function (part) {
      const item = part.split('=');
      if (item[0]) params[item[0]] = decodeURIComponent(item[1] || '');
    });

    // 解析 hash 参数
    hashParams.split('&').forEach(function (part) {
      const item = part.split('=');
      if (item[0]) params[item[0]] = decodeURIComponent(item[1] || '');
    });
    return params;
  }
}

/**
 * 本地下载文件
 * @param {*} fileName
 * @param {*} content
 */
export function localDownloadFile(fileName, content) {
  // 创建隐藏的可下载链接
  const element = document.createElement('a');
  // 可以设置为文件内容
  const blob = new Blob([content], {
    type: 'text/plain'
  });
  const fileUrl = URL.createObjectURL(blob);
  element.setAttribute('href', fileUrl);
  element.setAttribute('download', fileName);
  // 触发下载
  document.body.appendChild(element);
  element.click();
  // 移除元素
  document.body.removeChild(element);
  // 释放URL对象
  URL.revokeObjectURL(fileUrl);
}

/**
 * 下载一个文件
 * @param {*} fileUrl 文件地址
 * @param {*} fileName 文件名
 */
export function downloadFile(fileUrl, fileName) {
  // 创建隐藏的可下载链接
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName;
  document.body.appendChild(a);
  // 模拟点击下载
  a.click();
  // 删除临时创建的<a>标签
  document.body.removeChild(a);
}

/**
 * 判断元素是否在可视区域
 */
export function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * base64转blob
 * @param {*} dataurl
 */
export const base64ToBlob = dataurl => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};

/**
 * blob转File
 * @param {*} theBlob
 * @param {*} fileName
 */
export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return new File([theBlob], fileName, {
    type: theBlob.type,
    lastModified: Date.now()
  });
};

/**
 * base转File
 * @param {*} dataurl
 * @param {*} fileName
 */
export const base64ToFile = (dataurl, fileName) => {
  const blob = base64ToBlob(dataurl);
  return blobToFile(blob, fileName);
};

/**
 * 通过图片裁切的数据构建服务端特定的数据
 * @param {any} processData
 * @returns {any}
 */
export function buildOssUploadProcessData(processData) {
  const { cropperData, blurryDegree, lightDegree } = processData;
  let blurryDegreeData = '';
  let lightDegreeData = '';
  if (blurryDegree > 0) {
    blurryDegreeData = `,/blur,r_10,s_${blurryDegree * 2}`;
  }
  if (lightDegree) {
    lightDegreeData = `,/bright,${(lightDegree - 10) * 5}`;
  }
  return `image/crop,x_${cropperData.x.toFixed()},y_${cropperData.y.toFixed()},w_${cropperData.width.toFixed()},h_${cropperData.height.toFixed()}`;
}

/**
 * 返回图片地址
 *
 * @param   {[type]}  url   [url 服务端图片地址]
 * @param   {[type]}  mode  [mode 适配的图片显示模式]
 *
 * @return  {[type]}        [return url]
 */
export function buildUrlByMode(url, mode) {
  if (url.indexOf('have-wap-image') != -1) {
    if (url.indexOf('mode') != -1) {
      return url;
    } else {
      return `${url}&mode=${mode}`;
    }
  } else {
    if (url.indexOf('mode') != -1) {
      return url;
    } else {
      return `${url}?mode=${mode}`;
    }
  }
}
export const parseQueryString = url => {
  return [...new URL(url).searchParams].reduce(
    (cur, [key, value]) => ((cur[key] = value), cur),
    {}
  );
};

/**
 * 验证文件格式与大小
 * @param file 文件
 * @param that 提示消息类型
 * @param type 类型
 * @param limitSize 图片的限制大小
 * @returns {Boolean} 验证通过还是失败
 */
export function checkUploadType(file, that, type = 1, limitSize = 2, callback) {
  const typeList = type === 1 ? ['png', 'jpeg'] : type;
  let typeArr = file.type.toLowerCase().split('/');
  const isType = typeList.includes(typeArr[typeArr.length - 1]);
  const isLt2M = file.size / 1024 / 1024 < limitSize;
  if (!isType) {
    that.$vhMessage({
      message: i18n.t('k_004001', [typeList.join('、')]),
      showClose: true,
      // duration: 0,
      type: 'error',
      customClass: 'zdy-info-box'
    });
    return false;
  }
  if (!isLt2M) {
    that.$vhMessage({
      message: i18n.t('k_004002', [`${limitSize}M`]),
      showClose: true,
      // duration: 0,
      type: 'error',
      customClass: 'zdy-info-box'
    });
    return false;
  }
  /*
  let imgSrc = window.URL.createObjectURL(file);
  let img = new Image();
  img.src = imgSrc;
  img.onload = function () {
    // 我在这里就可以获取到图片的宽度和高度了 img.width 、img.height
    if (img.width !== 1280 && img.height !== 720) {
      that.$vhMessage({
        message: `请上传1280*720尺寸图片`,
        showClose: true,
        // duration: 0,
        type: 'error',
        customClass: 'zdy-info-box'
      });
      return false;
    }
  };
  */
  if (isType && isLt2M) {
    if (callback) {
      callback();
    } else {
      return true;
    }
  }
}

/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
export const debounce = (function () {
  let timeout = null;
  return function (func, wait = 500, immediate = false) {
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout);
    // 立即执行，此类情况一般用不到
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) typeof func === 'function' && func();
    } else {
      // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
      timeout = setTimeout(function () {
        typeof func === 'function' && func();
      }, wait);
    }
  };
})();

/**
 *  判断传入参数的类型，以字符串的形式返回
 **/
export function dataType(obj) {
  if (obj === null) return 'Null';
  if (obj === undefined) return 'Undefined';
  return Object.prototype.toString.call(obj).slice(8, -1);
}

/**
 * 处理对象参数值，排除对象参数值为”“、null、undefined，并返回一个新对象
 **/
export function dealObjectValue(obj) {
  let param = {};
  if (obj === null || obj === undefined || obj === '') return param;
  for (let key in obj) {
    if (dataType(obj[key]) === 'Object') {
      param[key] = dealObjectValue(obj[key]);
    } else if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      param[key] = obj[key];
    }
  }
  return param;
}

// element-ui 中用来判断 text-overflow 的工具方法 start

const SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;
const ieVersion = Number(document.documentMode);

/* istanbul ignore next */
const camelCase = function (name) {
  return name
    .replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    })
    .replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
export const getStyle =
  ieVersion < 9
    ? function (element, styleName) {
        if (!element || !styleName) return null;
        styleName = camelCase(styleName);
        if (styleName === 'float') {
          styleName = 'styleFloat';
        }
        try {
          switch (styleName) {
            case 'opacity':
              try {
                return element.filters.item('alpha').opacity / 100;
              } catch (e) {
                return 1.0;
              }
            default:
              return element.style[styleName] || element.currentStyle
                ? element.currentStyle[styleName]
                : null;
          }
        } catch (e) {
          return element.style[styleName];
        }
      }
    : function (element, styleName) {
        if (!element || !styleName) return null;
        styleName = camelCase(styleName);
        if (styleName === 'float') {
          styleName = 'cssFloat';
        }
        try {
          var computed = document.defaultView.getComputedStyle(element, '');
          return element.style[styleName] || computed ? computed[styleName] : null;
        } catch (e) {
          return element.style[styleName];
        }
      };

// element-ui 中用来判断 text-overflow 的工具方法 end

// base64加密
export const base64Encode = function (str) {
  return Base64.encode(str);
};

// base64解密
export const base64Decode = function (str) {
  return Base64.decode(str);
};
export const sizeTostr = size => {
  size = Number(size);
  var data = '';
  if (size < 1 * 1024) {
    //如果小于0.1KB转化成B
    data = size.toFixed(1) + 'B';
  } else if (size < 1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(1) + 'KB';
  } else if (size < 1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(1) + 'M';
  } else {
    //其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(1) + 'G';
  }
  var sizestr = data + '';
  var len = sizestr.indexOf('.');
  var dec = sizestr.substr(len + 1, 2);
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
};
export const secondToTime = function (val, type) {
  // type= 1 :表示强制用 hh:MM:ss 表示
  let time = val;
  let hours = String.prototype.padStart.call(Math.floor(time / (60 * 60)), 2, '0');
  time = time % (60 * 60);
  let minutes = String.prototype.padStart.call(Math.floor(time / 60), 2, '0');
  time = time % 60;
  let seconds = String.prototype.padStart.call(Math.floor(time), 2, '0');
  let totalTime = '';
  if (hours != '00' || type == 1) {
    totalTime = hours + ':' + minutes + ':' + seconds;
  } else {
    totalTime = minutes + ':' + seconds;
  }
  return totalTime;
};
